import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// =====================
// EXPORT EXCEL
// =====================
export const exporterExcel = (saisies, totaux, filtreInfo) => {
  const lignes = saisies.map(s => {
    const bov_nbr = (s.bovins_brut||0)-(s.camelins||0)-(s.sorties_bovins||0);
    const bov_poids = (parseFloat(s.poids_bovins)||0)-(parseFloat(s.poids_camelins)||0)-(parseFloat(s.vf_bovins)||0);
    const ovi_nbr = (s.ovins||0)-(s.sorties_ovins||0);
    const ovi_poids = (parseFloat(s.poids_ovins)||0)-(parseFloat(s.vf_ovins)||0);
    const cap_nbr = (s.caprins||0)-(s.sorties_caprins||0);
    const cap_poids = (parseFloat(s.poids_caprins)||0)-(parseFloat(s.vf_caprins)||0);
    const por_nbr = (s.porcins||0)-(s.sorties_porcins||0);
    const por_poids = (parseFloat(s.poids_porcins)||0)-(parseFloat(s.vf_porcins)||0);
    return {
      'Date': new Date(s.date_saisie).toLocaleDateString('fr-FR'),
      'Abattoir': s.abattoir_nom,
      'Statut': s.statut,
      'Bovins Nets (Têtes)': bov_nbr,
      'Bovins Nets (Poids kg)': parseFloat(bov_poids.toFixed(2)),
      'Camelins (Têtes)': s.camelins||0,
      'Camelins (Poids kg)': parseFloat(s.poids_camelins||0),
      'Ovins Nets (Têtes)': ovi_nbr,
      'Ovins Nets (Poids kg)': parseFloat(ovi_poids.toFixed(2)),
      'Caprins Nets (Têtes)': cap_nbr,
      'Caprins Nets (Poids kg)': parseFloat(cap_poids.toFixed(2)),
      'Porcins Nets (Têtes)': por_nbr,
      'Porcins Nets (Poids kg)': parseFloat(por_poids.toFixed(2)),
    };
  });

  // Ligne totaux
  lignes.push({
    'Date': 'TOTAUX',
    'Abattoir': `${saisies.length} saisies`,
    'Statut': '',
    'Bovins Nets (Têtes)': totaux.bov_nbr,
    'Bovins Nets (Poids kg)': parseFloat(totaux.bov_poids.toFixed(2)),
    'Camelins (Têtes)': totaux.cam_nbr,
    'Camelins (Poids kg)': parseFloat(totaux.cam_poids.toFixed(2)),
    'Ovins Nets (Têtes)': totaux.ovi_nbr,
    'Ovins Nets (Poids kg)': parseFloat(totaux.ovi_poids.toFixed(2)),
    'Caprins Nets (Têtes)': totaux.cap_nbr,
    'Caprins Nets (Poids kg)': parseFloat(totaux.cap_poids.toFixed(2)),
    'Porcins Nets (Têtes)': totaux.por_nbr,
    'Porcins Nets (Poids kg)': parseFloat(totaux.por_poids.toFixed(2)),
  });

  const ws = XLSX.utils.json_to_sheet(lignes);
  
  // Largeur des colonnes
  ws['!cols'] = [
    {wch:12},{wch:22},{wch:10},
    {wch:18},{wch:18},
    {wch:16},{wch:16},
    {wch:16},{wch:16},
    {wch:16},{wch:16},
    {wch:16},{wch:16},
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Saisies SOGAS');

  const dateExport = new Date().toLocaleDateString('fr-FR').replace(/\//g, '-');
  const nomFichier = `SOGAS_Saisies_${filtreInfo}_${dateExport}.xlsx`;
  
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), nomFichier);
};

// =====================
// MODELE IMPORT
// =====================
export const telechargerModele = () => {
  const modele = [{
    'date_saisie': '2026-03-14',
    'abattoir_code': 'ABT-DKR',
    'bovins_brut': 100,
    'poids_bovins': 25000,
    'camelins': 10,
    'poids_camelins': 3000,
    'sorties_bovins': 5,
    'vf_bovins': 1000,
    'ovins': 200,
    'poids_ovins': 7000,
    'sorties_ovins': 0,
    'vf_ovins': 400,
    'caprins': 50,
    'poids_caprins': 1500,
    'sorties_caprins': 0,
    'vf_caprins': 0,
    'porcins': 20,
    'poids_porcins': 800,
    'sorties_porcins': 0,
    'vf_porcins': 0,
    'observations': 'Exemple'
  }];

  const ws = XLSX.utils.json_to_sheet(modele);
  ws['!cols'] = Array(21).fill({wch:16});
  
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Modele Import SOGAS');
  
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'SOGAS_Modele_Import.xlsx');
};

// =====================
// PARSER IMPORT
// =====================
export const parserFichierImport = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'array', cellDates: true });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const lignes = XLSX.utils.sheet_to_json(ws, { defval: '' });
        resolve(lignes);
      } catch (err) {
        reject(new Error('Fichier invalide.'));
      }
    };
    reader.readAsArrayBuffer(file);
  });
};
